import React from 'react';

import { ListRow, Text } from '@betterment/samba-react';

import { formatContributionValue } from './utils';

import type { PayrollContributionConfig } from './types';

type Props = {
  config: PayrollContributionConfig;
};

export const PayrollContributionConfigRow: React.FC<Props> = ({ config }) => {
  const baseText = formatContributionValue(config.value, config.destinationName);

  return (
    <ListRow key={config.id} css={{ padding: 'space.0', alignItems: 'start' }}>
      <ListRow.LeadingContent>
        <Text>{baseText}</Text>
      </ListRow.LeadingContent>
    </ListRow>
  );
};
